import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import { filter, tap, takeUntil } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { Subject } from 'rxjs';

import { IAuroraState } from '@apps/aurora.state';
import * as fromAuthStore from '@apps/auth/store';
import { Profile } from '@apps/auth/models/profile';

@Component({
    selector: 'aa-profile-step2',
    templateUrl: './profile-step2.component.html',
    styleUrls: [
        '../profile.component.scss',
        './profile-step2.component.scss'
    ],
    standalone: false
})
export class ProfileStep2Component implements OnInit, OnDestroy
{
    private destroyator = new Subject();
    public form: UntypedFormGroup;
    public profile: Profile;

    constructor (
        private formBuilder: UntypedFormBuilder,
        private store: Store<IAuroraState>
    )
    {
    }

    ngOnInit ()
    {
        this.store
            .pipe(
                select(fromAuthStore.getProfile),
                filter((p: Profile) => p !== null),
                tap((p: Profile) =>
                {
                    this.profile = p;
                    this.createForm();
                }),
                takeUntil(this.destroyator)
            )
            .subscribe();
    }

    ngOnDestroy (): void
    {
        this.destroyator.next(null);
        this.destroyator.complete();
    }

    onSubmit = () =>
    {
        if (this.form.invalid)
        {
            for (const control in this.form.controls)
            {
                this.form.controls[control].markAsDirty();
            }

            return;
        }

        const profile: Profile = {
            phoneNumber: this.form.get('phoneNumber').value,
            mobile: this.form.get('mobile').value
        };
        this.store.dispatch(fromAuthStore.AuthProfileStoreActions.AuthProfileStep2Changed({ profile }));
    };

    // onContinue = () =>
    // {
    //     this.store.dispatch(fromAuthStore.AuthProfileStoreActions.AuthProfileStep2Continued());
    // }

    onCancel = () =>
    {
        this.store.dispatch(fromAuthStore.AuthProfileStoreActions.AuthProfileStepCanceled());
    };

    private createForm ()
    {
        this.form = this.formBuilder.group({
            phoneNumber: [this.profile.phoneNumber],
            mobile: [this.profile.mobile]
        });
    }
}
